import * as I from 'immutable';
import React from 'react';

import {CenteredSpinner} from 'app/components/CenteredSpinner';
import {LayoutWrapper} from 'app/components/LayoutWrapper';
import {ApiOrganization, ApiOrganizationUser} from 'app/modules/Remote/Organization/types';
import {useWorkflowsContext} from 'app/pages/Agent/WorkflowsProvider';
import {LoggedInAuth, LoggedInUserActions} from 'app/providers/AuthProvider';

import {AgentWorkflow} from './AgentWorkflow';
import {RunView} from './RunView';

type Props = {
  workflowId: string;
  runId?: string;
  auth: LoggedInAuth;
  profile: I.ImmutableOf<ApiOrganizationUser>;
  organization: I.ImmutableOf<ApiOrganization>;
  loggedInUserActions: LoggedInUserActions;
};

export const AgentWorkflowSwitch: React.FC<Props> = ({
  workflowId,
  auth,
  profile,
  organization,
  loggedInUserActions,
  runId,
}) => {
  const {workflows, isFetchingWorkflows} = useWorkflowsContext();

  const selectedWorkflow = workflows?.find((w) => w.id.toString() === workflowId);

  let content;
  if (isFetchingWorkflows) {
    content = (
      <div style={{width: '100%', height: '100%'}}>
        <CenteredSpinner />
      </div>
    );
  } else if (!workflows) {
    content = <div>No workflows or features found.</div>;
  } else if (runId && selectedWorkflow) {
    content = <RunView runId={runId} workflow={selectedWorkflow} />;
  } else if (selectedWorkflow) {
    content = <AgentWorkflow workflow={selectedWorkflow} features={selectedWorkflow.features} />;
  } else {
    content = <div>Run plan {workflowId} not found.</div>;
  }

  return (
    <LayoutWrapper
      auth={auth}
      profile={profile}
      organization={organization}
      loggedInUserActions={loggedInUserActions}
    >
      {content}
    </LayoutWrapper>
  );
};
